export const shouldRefreshAdminPermissions = (
    previousPath: string | null,
    nextPath: string | null
): boolean => {
    if (!nextPath) return false;

    const isAdminDashboardPath = nextPath === '/admin' || nextPath.startsWith('/admin/');
    const wasAdminDashboardPath = previousPath === '/admin' || previousPath?.startsWith('/admin/');

    if (!wasAdminDashboardPath && isAdminDashboardPath) return true;
    return false;
};
